import { Company } from "../../types/JobOffers";

export const jobOffers: Company[] = [

];
